<template>
  <div class="info">
    <h1 class="info__title">Ecosystems</h1>

    <dots-number activeDots='2'/>

    <div class="info text-center">
      <div class="info__header">
        <img class="info__img" src="/static/img/Ecosystems.svg" alt="">
        <p class="info__header-text">
          The organisation has open ecosystems and is a seamless network of highly autonomous,
          interdependent units that increasingly includes customers, suppliers, communities and
          a flexible workforce. It challenges traditional notions of hierarchy and the idea that the
          organisation is a self-contained entity.
        </p>
      </div>
      <div class="info__footer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      id: 1,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Network/Info.vue